import * as React from "react";
import { Modal } from "./modal";
import { statusLabel } from "../lead-status";
import type { ContactAttempt } from "./contact-attempt-stack";

function kstFull(iso: string): string {
  const d = new Date(new Date(iso).getTime() + 9 * 3600 * 1000);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}-${p(d.getUTCDate())} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`;
}

// 연락 시도 상세 리스트 + 본인 시도 삭제.
export function ContactAttemptsModal({
  open,
  onClose,
  attempts,
  meId,
  onDelete,
  deletingAt,
}: {
  open: boolean;
  onClose: () => void;
  attempts: ContactAttempt[];
  meId: string | null;
  onDelete: (at: string) => void;
  deletingAt?: string | null;
}): React.ReactElement {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="연락 시도 내역"
      description={`총 ${attempts.length}회 — 본인이 한 시도만 삭제할 수 있습니다.`}
    >
      <div className="max-h-[420px] overflow-y-auto -mx-1">
        {attempts.length === 0 ? (
          <div className="py-10 text-center text-[13px] text-ink-subtle">
            시도 내역이 없습니다.
          </div>
        ) : (
          <ol className="flex flex-col">
            {attempts.map((a, i) => {
              const mine = !!meId && a.userId === meId;
              return (
                <li
                  key={i}
                  className="flex items-center gap-2.5 px-1 py-2 border-b border-border last:border-b-0"
                >
                  <span className="text-[11px] text-ink-subtle tabular-nums w-5 shrink-0">
                    {i + 1}
                  </span>
                  <span
                    className="w-3 h-3 rounded-full shrink-0"
                    style={{ backgroundColor: a.color ?? "#9ca3af" }}
                    aria-hidden
                  />
                  <span className="text-[13px] text-ink truncate flex-1 min-w-0">
                    {a.name}
                  </span>
                  <span className="text-[11px] text-ink-muted shrink-0 w-8 text-center">
                    {statusLabel(a.status)}
                  </span>
                  <span className="text-[11px] text-ink-subtle tabular-nums shrink-0 w-[104px] text-right">
                    {kstFull(a.at)}
                  </span>
                  {mine ? (
                    <button
                      type="button"
                      className="text-[11px] text-danger hover:underline disabled:opacity-50 shrink-0 w-8 text-right"
                      disabled={deletingAt === a.at}
                      onClick={() => onDelete(a.at)}
                    >
                      삭제
                    </button>
                  ) : (
                    <span className="w-8 shrink-0" aria-hidden />
                  )}
                </li>
              );
            })}
          </ol>
        )}
      </div>
      <div className="flex justify-end pt-4 mt-2 border-t border-border">
        <button
          type="button"
          onClick={onClose}
          className="text-[13px] text-ink-muted hover:text-ink px-3 py-1.5"
        >
          닫기
        </button>
      </div>
    </Modal>
  );
}
